export default __webpack_public_path__ + "static/media/team-cat-04.c7702e1e.png";